import { Controller } from "@hotwired/stimulus"

// Per-row YouTube accordion: one controller element per month row.
// Lazily injects the iframe src on first expand so the page doesn't load up
// to 12 embeds at once and only contacts YouTube once the user opts in.
export default class extends Controller {
  static targets = ["panel", "iframe", "button"]
  static values = { url: String }

  toggle() {
    const panel = this.panelTarget
    const opening = panel.classList.contains("hidden")
    if (opening) {
      if (!this.iframeTarget.src) this.iframeTarget.src = this.urlValue
      panel.classList.remove("hidden")
      requestAnimationFrame(() => panel.classList.remove("opacity-0", "translate-y-2"))
    } else {
      panel.classList.add("opacity-0", "translate-y-2")
      panel.addEventListener("transitionend", () => panel.classList.add("hidden"), { once: true })
    }
    this.#setActive(opening)
  }

  // Primary-filled button with a white icon while open; standard look while closed.
  #setActive(active) {
    const b = this.buttonTarget
    b.classList.toggle("bg-primary", active)
    b.classList.toggle("text-white", active)
    b.classList.toggle("border-primary", active)
    b.classList.toggle("text-gray-700", !active)
    b.classList.toggle("border-gray-200", !active)
    b.classList.toggle("hover:bg-gray-50", !active)
  }
}
